const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsFlower = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.988 8.19c.027.005.023-.035.027-.056.069-.302.117-.593.205-.893.72-2.447 2.78-4.407 5.265-4.995 1.448-.344 2.922-.232 4.392-.125l.113 1.61v1.118l-.039.52c-.112 1.147-.45 2.249-1.054 3.229-1.106 1.799-2.993 3.081-5.092 3.4 2.794.424 5.166 2.55 5.899 5.273.404 1.5.305 3.068.173 4.602l-1.61.113h-1.1l-.521-.038c-3.324-.254-6.147-2.85-6.65-6.144-.407 2.803-2.564 5.173-5.29 5.9-1.5.4-3.057.298-4.59.17-.004-.345-.054-.69-.074-1.034-.063-1.09-.059-2.194.18-3.264.642-2.868 3.06-5.126 5.966-5.579a7.313 7.313 0 0 1-6.068-6.11c-.194-1.256-.09-2.505-.004-3.766.345-.004.69-.054 1.034-.074 1.264-.073 2.551-.057 3.771.307 2.61.778 4.686 3.127 5.066 5.836Z",
    style: {
      fill: "none",
      stroke: "#00a000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsFlower);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icons_flower_.572b633a289c42f06a673b3560fd7bc5.svg";